import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["innerHTML"];
import { readonly } from "vue";
import SRTManager from "@webgl/core/audio/SrtManager";
export default /*#__PURE__*/ _defineComponent({
    __name: 'AppCaptions',
    setup(__props) {
        const caption = readonly(SRTManager.currentSrt);
        return (_ctx, _cache) => {
            const _component_UITextSubtitle = _resolveComponent("UITextSubtitle");
            return (_unref(caption))
                ? (_openBlock(), _createBlock(_component_UITextSubtitle, { key: 0 }, {
                    default: _withCtx(() => [
                        _createElementVNode("span", {
                            class: "text-balance",
                            innerHTML: _unref(caption)
                        }, null, 8, _hoisted_1)
                    ]),
                    _: 1
                }))
                : _createCommentVNode("", true);
        };
    }
});
